import { initializeApp, getApp, getApps } from "https://www.gstatic.com/firebasejs/12.15.0/firebase-app.js";
import { getAnalytics, logEvent } from "https://www.gstatic.com/firebasejs/12.15.0/firebase-analytics.js";
import { getRemoteConfig, fetchAndActivate, getString } from "https://www.gstatic.com/firebasejs/12.15.0/firebase-remote-config.js";
import { getInstallations, getToken, getId } from "https://www.gstatic.com/firebasejs/12.15.0/firebase-installations.js";

let firebaseReadyPromise;

const initializeFirebase = async () => {
  if (firebaseReadyPromise) {
    return firebaseReadyPromise;
  }

  firebaseReadyPromise = (async () => {
    const firebaseConfig = {
      apiKey: "AIzaSyDKgItLCu1U1acOxWCe-aYt1GipYpED0UM",
      authDomain: "nomad-internet-main.firebaseapp.com",
      projectId: "nomad-internet-main",
      storageBucket: "nomad-internet-main.firebasestorage.app",
      messagingSenderId: "440892639579",
      appId: "1:440892639579:web:c6fe89c8542dcd7d6bf27e",
      measurementId: "G-VY7DCK90H7"
    };

    const firebaseApp = getApps().length ? getApp() : initializeApp(firebaseConfig);
    const firebaseAnalytics = getAnalytics(firebaseApp);
    const firebaseRemoteConfig = getRemoteConfig(firebaseApp);

    firebaseRemoteConfig.settings.minimumFetchIntervalMillis = 0;

    firebaseRemoteConfig.defaultConfig = {
      "homepage_version": "2.0",
      "reseller_page_version": "2.0",
      "how_nomad_works_page_version": "2.0",
      "plans_page_version": "2.0"
    };

    await fetchAndActivate(firebaseRemoteConfig);

    return {
      firebaseApp,
      firebaseAnalytics,
      firebaseRemoteConfig
    };
  })();

  return firebaseReadyPromise;
}

const getFirebaseApp = () => {
  return getApp();
}

const getFirebaseAnalytics = () => {
  const firebaseApp = getApp();
  return getAnalytics(firebaseApp);
}

const getFirebaseRemoteConfig = () => {
  const firebaseApp = getApp();
  return getRemoteConfig(firebaseApp);
}

const getFirebaseInstallationID = () => {
  const firebaseApp = getApp();
  const installations = getInstallations(firebaseApp);
  return getId(installations);
}

const getFirebaseInstallationAuthToken = () => {
  const firebaseApp = getApp();
  const installations = getInstallations(firebaseApp);
  return getToken(installations);
}

export {
  initializeFirebase,
  getFirebaseApp,
  getFirebaseAnalytics,
  getFirebaseRemoteConfig,
  getFirebaseInstallationID,
  getFirebaseInstallationAuthToken,
  fetchAndActivate,
  getString,
  logEvent
}
